export type ArticleRef = { id: string };

export type ArticleEndAction = 'loop' | 'next' | 'stop';

/** 单曲循环优先；否则按「自动下一篇」设置决定。 */
export function decideArticleEndAction(
  loopCurrent: boolean,
  autoPlayNext: boolean,
): ArticleEndAction {
  if (loopCurrent) return 'loop';
  if (autoPlayNext) return 'next';
  return 'stop';
}

export function nextArticleId(ids: string[], currentId: string): string | null {
  if (ids.length <= 1) return null;
  const idx = ids.indexOf(currentId);
  if (idx < 0) return ids[0] ?? null;
  return ids[(idx + 1) % ids.length] ?? null;
}

export function prevArticleId(ids: string[], currentId: string): string | null {
  if (ids.length <= 1) return null;
  const idx = ids.indexOf(currentId);
  if (idx < 0) return ids[ids.length - 1] ?? null;
  return ids[(idx - 1 + ids.length) % ids.length] ?? null;
}

export function createRandomBag(ids: string[], currentId?: string): string[] {
  const bag = [...ids];
  for (let i = bag.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = bag[i]!;
    bag[i] = bag[j]!;
    bag[j] = tmp;
  }
  if (currentId && bag.length > 1 && bag[0] === currentId) {
    const swap = bag.findIndex((id) => id !== currentId);
    if (swap > 0) {
      bag[0] = bag[swap]!;
      bag[swap] = currentId;
    }
  }
  return bag;
}

export function nextFromBag(
  bag: string[],
  currentId: string,
  allIds: string[],
): { nextId: string | null; bag: string[] } {
  if (allIds.length <= 1) return { nextId: null, bag };
  let nextBag = bag.length === allIds.length ? bag : createRandomBag(allIds, currentId);
  let idx = nextBag.indexOf(currentId);
  if (idx < 0) {
    nextBag = createRandomBag(allIds, currentId);
    idx = -1;
  }
  if (idx === nextBag.length - 1) {
    nextBag = createRandomBag(allIds, currentId);
    return { nextId: nextBag[0] ?? null, bag: nextBag };
  }
  return { nextId: nextBag[idx + 1] ?? nextBag[0] ?? null, bag: nextBag };
}

export function prevFromBag(
  bag: string[],
  currentId: string,
): { prevId: string | null } {
  if (bag.length <= 1) return { prevId: null };
  const idx = bag.indexOf(currentId);
  if (idx <= 0) return { prevId: bag[bag.length - 1] ?? null };
  return { prevId: bag[idx - 1] ?? null };
}
